import { BareActionContext } from 'vuex-typex'
import { FeedState } from '../state'
import { RootState } from '../..'
import authStore from '@/store/auth/auth-store'
import viewConvos from './view-convos'
import setFeedUser from '@/store/feed/actions/set-feed-user';
import { IUser } from '@/model/user';

export default async function viewMyConvos(context: BareActionContext<FeedState, RootState>)
{
    setFeedUser(context, <IUser>authStore.user)
    viewConvos(context)

    return
}
